import { WithStyles, withStyles } from "@material-ui/core/styles";
import { Theme, ThemeOptions } from "@material-ui/core/styles/createTheme";
// import getYear from "date-fns/get_year";
// import setYear from "date-fns/set_year";
import update from "immutability-helper";
import * as _ from "lodash";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Redirect, Route, Switch } from "react-router-dom";
import coachBackgroundImage from "src/assets/home-page-lander.jpg";
import Component from "src/shared/components/Component";
import LoadingGrid from "src/shared/components/LoadingGrid";
import Sidebar from "src/shared/components/sidebar/Sidebar";
import withAxios, { IAxiosProps } from "src/shared/components/withAxios";
import { ALL_SEASONS } from "src/constants";
import l from "src/l";
// import { Button} from "@material-ui/core";
import {
  ICoach,
  IDirectorParams,
  ISchool,
  ISeasonResponse,
  ISeasonResponsesAndSchoolActive,
  ISettings,
  ISport,
  ISurvey,
  IUser,
} from "src/api/types";
import TemplateEditorPage from "./pages/template-editor/TemplateEditorPage";
import CommentsPage from "./pages/CommentsPage";
import EvaluationPage from "./pages/EvaluationPage/EvaluationPage";
import IDirectorPageProps from "./pages/IDirectorPageProps";
import SurveyDataCenterPage from "./pages/SurveyDataCenter/SurveyDataCenterPage";
import AdministratorsPage from "./pages/administrators/administrators";
import DashboardPage from "./pages/dashboard/Dashboard";
import EditSchoolUser from "./pages/editSchoolUser";
import SubscriptionHistory from "./pages/subscriptionHistory";
import ReportHistory from "./pages/reportHistory";

import Seasons from "./pages/seasons/Seasons";
import SurveyPage from "./pages/survey/SurveyPage";
import { hexToRGB } from "src/util";
import SubscriptionPlan from "./pages/upgradeSubscription/subscriptionPlan";
import SubscriptionPlanUpgrade from "./pages/upgradeSubscription/subscriptionPlanUpgrade";

import AddonPlan from "./pages/upgradeSubscription/addonPlan";
import PurchasePlan from "./pages/upgradeSubscription/purchasePlan";
import StripePayment from "./pages/upgradeSubscription/stripePayment";
import StripePaymentSucess from "./pages/upgradeSubscription/stripePaymentSucess";
import CheckPaymentSucess from "./pages/upgradeSubscription/checkPaymentSucess";
import AddonPlanUpgrade from "./pages/upgradeSubscription/addonPlanUpgrade";

const SchoolContext = React.createContext<IDirectorPageProps>({} as any);
const SchoolContextConsumer = SchoolContext.Consumer;
export function withSchoolContext<P>(
  WrappedComponent: React.ComponentType<IDirectorPageProps & P>
) {
  return (props: P) => {
    return (
      <SchoolContextConsumer>
        {(schoolContext) => {
          return <WrappedComponent {...schoolContext} {...props} />;
        }}
      </SchoolContextConsumer>
    );
  };
}

const styles = (theme: Theme) => {
  const infoRgb = hexToRGB(theme.palette.info.main);
  const backgroundOpacity = "0.5";
  return {
    page: {
      background: `linear-gradient(rgba(${infoRgb}, ${backgroundOpacity}), rgba(${infoRgb}, ${backgroundOpacity})), url(${coachBackgroundImage})`,
      backgroundPosition: "left 50% top 0%",
      backgroundSize: "cover",
      height: "100%",
      overflow: "auto",
    },
  };
};

interface ITempDirectorPageProps extends RouteComponentProps {
  schoolSlug: string;
  user: IUser;
  setTheme: (theme: ThemeOptions) => void;
}

interface IDirectorPageState {
  directors: IUser[];
  settings?: ISettings;
  surveys: ISurvey[];
  school?: ISchool;
  sports?: ISport[];
  coaches?: ICoach[];
  seasons: ISeasonResponse[];
  seasonsSaved?: true;
  seasonsSaving?: true;
  schoolSeasonActive?: true;
  loadingSeasonsResponse?: true;
  loadingCoaches?: true;
  loadingDirectors: boolean;
  loadingSettings?: true;
  loadingSurveys?: true;
  failedToLoad?: true;
  userSubscription: any;
  isMeadSeason:any;

}

type IProps = ITempDirectorPageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

export default withAxios<ITempDirectorPageProps>(
  withStyles(styles)(
    class DirectorPage extends Component<IProps, IDirectorPageState> {
      public readonly state = this.buildState({
        directors: [],
        loadingDirectors: false,
        loadingSeasonsResponse: true,
        seasons: [],
        seasonsSaved: true,
        surveys: [],
        userSubscription: {},
        isMeadSeason:undefined
      });

      public async componentDidMount() {
        try {
          await this.loadSchoolDetails();
          await this.loadSchool();      
          this.loadSeasons(true);
          this.loadSettings();
          this.loadSports();
          this.loadCoaches();
      
        
        } catch (error) {
          console.error("Error during component mount", error);
        }
      }
      

      public componentDidUpdate(prevProps: IProps) {
        if (prevProps.schoolSlug !== this.props.schoolSlug) {
          this.setState({ school: undefined });
        }
      }

      public render(): React.ReactNode {
        const { classes, user, schoolSlug } = this.props;
        const {
          failedToLoad,
          school,
          sports,
          coaches,
          directors,
          loadingCoaches,
          loadingDirectors,
          loadingSurveys,
          surveys,
          settings,
          seasons,
          loadingSeasonsResponse,
          userSubscription
        } = this.state;
        if (failedToLoad === true) {
          return <div>Failed to load school</div>;
        }
        if (
          !!!user?.id ||
          !!!school ||
          !!!settings ||
          !!!sports ||
          !!!coaches
        ) {
          return (
            <div className={classes.page}>
              <LoadingGrid />
            </div>
          );
        }
        return (
          <SchoolContext.Provider
            value={{
              coaches,
              directors,
              loadCoaches: this.loadCoaches,
              loadDirectors: this.loadDirectors,
              loadSeasons: this.loadSeasons,
              loadSettings: this.loadSettings,
              loadSurveys: this.loadSurveys,
              loadSchool: this.loadSchool,
              loadingCoaches,
              loadingDirectors,
              loadingSeasonsResponse,
              loadingSurveys,
              school,
              seasons,
              settings,
              sports,
              surveys,
              userSubscription,
              loadUserSubscription:this.loadUserSubscription
            }}
          >
            <Sidebar>
              <Switch>
                <Route exact={true} path={`/${schoolSlug}`}>
                  <Redirect to={`/${schoolSlug}/dashboard`} />
                </Route>
                <Route
                  path={`/${schoolSlug}/evaluation/:surveyId/:sportId/:coachId`}
                  render={this.ParamsEvaluationPage}
                />
                <Route
                  path={`/${schoolSlug}/comments/:surveyId/:sportId/:coachId/:source`}
                  render={this.ParamsCommentsPage}
                />
                {/* <Route path={`/${schoolSlug}/coaches`} component={CoachesPage}/> */}
                <Route
                  path={`/${schoolSlug}/dashboard/:seasonName`}
                  render={this.ParamsDashboardPage}
                />
                <Route
                  path={`/${schoolSlug}/dashboard`}
                  component={this.ParamsDashboardPage}
                />
                <Route
                  path={`/${schoolSlug}/editschooluser`}
                  component={EditSchoolUser}
                />
                <Route
                  path={`/${schoolSlug}/upgrade-subscription`}
                  component={SubscriptionPlan}
                />
                 <Route
                  path={`/${schoolSlug}/plan-details`}
                  component={SubscriptionPlanUpgrade}
                />
                 <Route
                  path={`/${schoolSlug}/addon-details`}
                  component={AddonPlanUpgrade}
                />
                <Route
                  path={`/${schoolSlug}/addon-plans`}
                  component={AddonPlan}
                />
                <Route
                  path={`/${schoolSlug}/purchase-plan`}
                  component={PurchasePlan}
                />
                <Route
                  path={`/${schoolSlug}/subscription-history`}
                  component={SubscriptionHistory}
                />
                <Route
                  path={`/${schoolSlug}/report-history`}
                  component={ReportHistory}
                />
                <Route
                  path={`/${schoolSlug}/stripe-payment`}
                  component={StripePayment}
                />
                <Route
                  path={`/${schoolSlug}/stripe-payment-sucess`}
                  component={StripePaymentSucess}
                />
                <Route
                  path={`/${schoolSlug}/check-payment-sucess`}
                  component={CheckPaymentSucess}
                />
                <Route
                  path={`/${schoolSlug}/survey/edit/:templateId`}
                  component={this.ParamsSurveyEditPage}
                />
                <Route
                  path={`/${schoolSlug}/edit-template/:templateId`}
                  component={this.ParamsTemplateEditorPage} />
                <Route path={`/${schoolSlug}/survey`} component={SurveyPage} />
                <Route
                  path={`/${schoolSlug}/administrators`}
                  component={AdministratorsPage}
                />
                <Route
                  path={`/${schoolSlug}/seasons`}
                  component={this.ParamsSeasons}
                />
                <Route
                  path={`/${schoolSlug}/survey-data-center`}
                  component={SurveyDataCenterPage}
                />
              </Switch>
            </Sidebar>
          </SchoolContext.Provider>
        );
      }

      private readonly loadSchool = async () =>
        this.runCancellableStatefulAsync(
          this,
          {
            failedToLoad: undefined,
          },
          {},
          async () => {
            this.setState({ userSubscription: {} })
            const { schoolSlug } = this.props;
            const school = await this.buildGetWithParams<
              ISchool,
              IDirectorParams
            >(
              this,
              `school/${schoolSlug}`
            )({ schoolSlug });
            this.setState({ school }, () => {
              this.loadUserSubscription()
            });
            const { primaryColor, secondaryColor } = school;
            // TODO Check if they are valid hex values
            if (primaryColor !== "" && secondaryColor !== "") {
              // setTheme({
              // palette: {
              // primary: {
              //   main: primaryColor,
              // },
              // secondary: {
              //   main: secondaryColor,
              // },
              // },
              // });
            }
          },
          () => {
            this.setState({ userSubscription: {} })
            const { history } = this.props;
            this.setState({ failedToLoad: true });
            history.push(`/`);
            // window.alert(`Failed to load ${this.props.schoolSlug}`);
          }
        );
      private readonly loadUserSubscription = async () => {
       return this.runCancellableStatefulAsync(
          this,
          {
            failedToLoad: undefined,
          },
          {},
          async () => {
            const userSubscription: any = await this.buildGet(
              this,
              `payment/getOneHistory/${this.state.school?.id}`
            )();
    
            if (userSubscription?.status) {
              
              this.setState({ userSubscription: userSubscription?.data });
            }
          },
          () => {
            this.setState({ userSubscription: {} })
            this.setState({ failedToLoad: true });
      
          }
        );
      
      }
      private readonly loadSports = () =>
        void this.runCancellableStatefulAsync(
          this,
          {},
          {},
          async () => {
            this.setState({
              sports: await this.buildGet<ISport[]>(this, "sport")(),
            });
          },
          () => {
            this.setState({ failedToLoad: true });
            window.alert("Failed to load sports");
          }
        );

      private readonly loadCoaches = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loadingCoaches: true,
          },
          {
            loadingCoaches: undefined,
          },
          async () => {
            const { schoolSlug } = this.props;
            this.setState({
              coaches: await this.buildGetWithParams<ICoach[], IDirectorParams>(
                this,
                "coach"
              )({ schoolSlug }),
            });
          },
          () => {
            this.setState({ failedToLoad: true, loadingCoaches: undefined });
            window.alert("Failed to load coaches");
          }
        );

      private readonly loadSettings = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loadingSettings: true,
          },
          {
            loadingSettings: undefined,
          },
          async () => {
            this.setState({
              settings: await this.buildGet<ISettings>(this, "settings")(),
            });
          },
          () => {
            this.setState({
              failedToLoad: true,
              loadingSettings: undefined,
            });
          }
        );

      private readonly loadDirectors = () =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loadingDirectors: true,
          },
          {
            loadingDirectors: false,
          },
          async () => {
            const { schoolSlug } = this.props;
            this.setState({
              directors: await this.buildGetWithParams<
                IUser[],
                IDirectorParams
              >(
                this,
                "director"
              )({ schoolSlug }),
            });
          },
          () => {
            this.setState({ failedToLoad: true });
            window.alert("Failed to load directors");
          }
        );

      private readonly loadSurveys = async () => {
        await this.runCancellableStatefulAsync(
          this,
          {
            loadingSurveys: true,
          },
          {
            loadingSurveys: undefined,
          },
          async () => {
            const { schoolSlug } = this.props;
            const surveys = await this.buildGetWithParams<
              ISurvey[],
              IDirectorParams
            >(
              this,
              "survey"
            )({ schoolSlug });
            this.setState({ surveys });
          },
          () => {
            this.setState({ failedToLoad: true, loadingSurveys: undefined });
            window.alert("Failed to load surveys");
          }
        );
      };

      private readonly setSeason = (
        season: ISeasonResponse,
        seasonName: string,
        startDate: number
      ) => {
        this.setState((prevState) =>
          update(prevState, {
            seasons: {
              [prevState.seasons.indexOf(season)]: {
                name: { $set: seasonName },
                startDate: { $set: startDate },
              },
            },
            seasonsSaving: { $set: true },
          })
        );
      };

      private readonly seasonsChange = (seasons: ISeasonResponse[]) => {
        this.setState({
          seasons,
          seasonsSaving: true,
        });
      };

      private readonly loadSeasons = (showLoading?: true) =>
        void this.runCancellableStatefulAsync(
          this,
          {
            loadingSeasonsResponse:
              showLoading !== undefined ? true : undefined,
          },
          {
            loadingSeasonsResponse: undefined,
          },
          async () => {
            const { school } = this.state;
            if (school === undefined) {
              return;
            }
            if (showLoading === undefined) {
              this.setState({
                seasonsSaving: true,
              });
            }
            const seasonResponsesAndSchoolActive =
              await this.buildGet<ISeasonResponsesAndSchoolActive>(
                this,
                `seasons/${school.id}`
              )();
            this.setState({
              schoolSeasonActive:
                seasonResponsesAndSchoolActive.schoolSeasonActive,
              seasons: seasonResponsesAndSchoolActive.seasons,
              seasonsSaving: undefined,
            });
          },
          () => {
            this.setState({ seasonsSaved: undefined });
            window.alert("Error loading seasons");
          }
        );

        // private readonly ParamsDashboardPage = ({
        //   match,
        //   history,
        // }: RouteComponentProps<{ seasonName: string }, {}>) => {
        //   const seasonName = match.params.seasonName;
        
        //   if (!seasonName) {
        //     const { schoolSlug } = this.props;
        //     const { seasons, loadingSeasonsResponse } = this.state;
        //     if (seasons.length === 0 && loadingSeasonsResponse === true) {
        //       return <div>Loading...</div>;
        //     }       
        //     const getSeasonName = () => {
        //       const today = new Date();
        //     console.log("this.state.isMeadSeason why?", this.state.isMeadSeason)
        //       if (this.state.isMeadSeason) {
        //         const year = today.getFullYear();
            
        //         const fallStart = new Date(`${year}-08-10`);
        //         const winterStart = new Date(`${year}-11-25`);
        //         const springStart = new Date(`${year+1}-03-10`); // assuming spring falls into next year
            
        //         if (today >= fallStart && today < winterStart) {return "FALL";}
        //         if (today >= winterStart && today < springStart) {return "WINTER";}
        //         return "SPRING";
        //       } else {
        //         const month = new Date().getMonth() + 1; // Adjust months to start from 1 (January = 1)
        //       if (month >= 8 && month <= 12) {return "FALL";} // August to December
        //       if (month >= 1 && month <= 4) {return "WINTER";} // January to April
        //       if (month >= 5 && month <= 7) {return "SPRING";} // May to July
        //       return ALL_SEASONS; // Default
        //       }
        //     };
            
        
        //     const toSeasonName = getSeasonName();
        //     history.replace(l`/${schoolSlug}/dashboard/${toSeasonName}`);
        //     // return null;
        //   }       
        //   return <DashboardPage seasonName={seasonName} history={history}/>;
        // };
        

        private readonly ParamsDashboardPage = ({
          match,
          history,
        }: RouteComponentProps<{ seasonName: string }, {}>) => {
          const { isMeadSeason, seasons, loadingSeasonsResponse } = this.state;
          const seasonName = match.params.seasonName;
          const { schoolSlug } = this.props;
        
          // Step 1: Agar isMeadSeason abhi load nahi hua hai
          if (isMeadSeason === undefined) {
            return <div>Loading Midseason Info...</div>;
          }
        
          // Step 2: Agar seasonName URL mein nahi hai
          if (!seasonName) {
            // Agar abhi seasons load ho rahe hain
            if (seasons.length === 0 && loadingSeasonsResponse === true) {
              return <div>Loading...</div>;
            }
        
            // Step 3: Season ka naam calculate karo
            const getSeasonName = () => {
              const today = new Date();
        console.log("ismidses why?", isMeadSeason)
              if (isMeadSeason) {
                const year = today.getFullYear();
                const fallStart = new Date(`${year}-08-10`);  // Aug 10
                const winterStart = new Date(`${year}-11-25`); // Nov 25
                const springStart = new Date(`${year}-03-10`); // Mar 10
                const winterStartPrevYear = new Date(`${year - 1}-11-25`); // Nov 25 previous year
        
                // Check if we're in winter from previous year (Nov 25 - Mar 9)
                if (today < springStart && today >= winterStartPrevYear) {return "WINTER";} // Before Mar 10 (current year)
                if (today >= springStart && today < fallStart) {return "SPRING";} // Mar 10 to Aug 9
                if (today >= fallStart && today < winterStart) {return "FALL";} // Aug 10 to Nov 24
                return "WINTER"; // After Nov 25 (current year)
              } else {
                const month = new Date().getMonth() + 1; // Adjust months to start from 1 (January = 1)
                if (month >= 8 && month <= 12) {return "FALL";} // August to December
                if (month >= 1 && month <= 4) {return "WINTER";} // January to April
                if (month >= 5 && month <= 7) {return "SPRING";} // May to July
                return ALL_SEASONS; // Default
              }
            };
        
            // Step 4: Redirect kar do calculated season pe
            const toSeasonName = getSeasonName();
            history.replace(l`/${schoolSlug}/dashboard/${toSeasonName}`);
            // return null;
          }
        
          // Step 5: Agar seasonName hai, to Dashboard render karo
          return <DashboardPage seasonName={seasonName} history={history}/>;
        };
        
      private readonly ParamsEvaluationPage = ({
        match,
        history,
      }: RouteComponentProps<
        { coachId: string; sportId: string; surveyId: string },
        {}
      >) => {
        return this.useSport(match, (sport) =>
          this.useCoach(match, (coach) => {
            const surveyId = parseInt(match.params.surveyId, 10);
            return (
              <EvaluationPage
                history={history}
                surveyId={surveyId}
                coach={coach}
                sport={sport}
              />
            );
          })
        );
      };

      private readonly ParamsSurveyEditPage = ({
        match,
        history,
      }: RouteComponentProps<{ templateId: string }, {}>) => {
        const { school } = this.state;
        const parsedTemplateId = parseInt(match.params.templateId, 10);
        const { schoolSlug } = this.props; 
console.log("schoolSlug", schoolSlug)
        if (isNaN(parsedTemplateId) || school === undefined) {
          return null;
        }

        // const handleEditClick = () => {
        //   // Navigate to the edit page with the templateId and schoolSlug
        //   history.push(`/${schoolSlug}/edit-template/${parsedTemplateId}`);
        // };

        return (
          <>
          
            {/* <Button
            className="edit-btn-temp"
              variant="contained"
              color="primary"
              onClick={handleEditClick}
            >
            Edit template
            </Button> */}
            <TemplateEditorPage
              isEditorMode={false}
              templateId={parsedTemplateId}
              history={history}
              schoolId={school.id}
              schoolSlug={schoolSlug}
            />
          </>
        );
      };

      private ParamsTemplateEditorPage = ({
        match,
        history,
      }: RouteComponentProps<{ templateId: string }, {}>) => {
        const { school } = this.state;
        const { schoolSlug } = this.props; 
        const parsedTemplateId = parseInt(match.params.templateId, 10);
        return isNaN(parsedTemplateId) || school === undefined ? null : (
          <TemplateEditorPage
            isEditorMode={true}
            templateId={parsedTemplateId}
            history={history}
            schoolId={school.id}
            schoolSlug={schoolSlug}
          />
        );
      };

      private readonly ParamsCommentsPage = ({
        location,
        history,
        match,
      }: RouteComponentProps<
        { sportId: string; coachId: string; surveyId: string; source: string },
        {}
      >) => {
        return this.useSport(match, (sport) =>
          this.useCoach(match, (coach) => {
            const surveyId = parseInt(match.params.surveyId, 10);
            const source: number = parseInt(match.params.source, 10);
            return (
              <CommentsPage
                responseSource={source}
                surveyId={surveyId}
                coach={coach}
                sport={sport}
              />
            );
          })
        );
      };

      private readonly ParamsSeasons = ({
        match,
        history,
      }: RouteComponentProps<{}, {}>) => {
        const { schoolSeasonActive, seasonsSaved, seasonsSaving } = this.state;
        return (
          <Seasons
            saved={seasonsSaved}
            saving={seasonsSaving}
            schoolSeasonActive={schoolSeasonActive}
            seasonsChange={this.seasonsChange}
            setSeason={this.setSeason}
          />
        );
      };

      private readonly loadSchoolDetails = async () => {
        try {
          const schools = await this.buildGet<ISchool[]>(this, "school")();

        console.log("All schoooll data", schools)
          const matchedSchoolId = schools?.find(
            (item) => item.slug === this.props.schoolSlug
          )?.id;
          console.log("matchedSchoolId", schools)
          if(matchedSchoolId){
          const res: any = await this.buildGet<IUser>(this, `/school/getOneSchools/${matchedSchoolId}`)()
          const isMidSeason = res?.data?.ismidseason;
      
          this.setState({ isMeadSeason: isMidSeason });
          }else{
          const res2: any = await this.buildGet<IUser>(this, `/school/getOneSchoolSlug/${this.props.schoolSlug}`)()
          const isMidSeason = res2?.data?.ismidseason;
      
          this.setState({ isMeadSeason: isMidSeason });
          console.log("get data using school slug", res2)
          }
         
        } catch (error) {
          console.error("Failed to load school details:", error);
          this.setState({ isMeadSeason: false }); // fallback default
        }
      };

      private readonly useCoach = (
        { params: { coachId } }: { params: { coachId: string } },
        render: (coach: ICoach) => React.ReactNode
      ) => {
        if (this.state.coaches === undefined) {
          return <LoadingGrid />;
        }
        const parsedCoachId = parseInt(coachId, 10);
        const coach = this.state.coaches.find((c) => c.id === parsedCoachId);
        if (coach === undefined) {
          return `Unfound coach: ${coachId}`;
        }
        return render(coach);
      };

      private readonly useSport = (
        { params: { sportId } }: { params: { sportId: string } },
        render: (sport: ISport) => React.ReactNode
      ) => {
        if (this.state.sports === undefined) {
          return <LoadingGrid />;
        }
        const parsedSportId = parseInt(sportId, 10);
        const sport = this.state.sports.find((s) => s.id === parsedSportId);
        if (sport === undefined) {
          return `Unfound sport: ${sportId}`;
        }
        return render(sport);
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/features/director/DirectorPage.tsx